module.exports = __webpack_public_path__ + "static/media/background.24253656.png";